// Affiliate Search
export const US_ZIPCODE_DIGITS = 5;
export const BLOOD_DRAW_FILTERS = ['allowWalkIn', 'allowWeekend', 'allowScheduleOnline', 'allowSchedulePhone', 'allowMobile']

// Cookies
export const ANALYTICS_COOKIES = 'GalleriSessionAnalytics';

export const USER_METRICS_COOKIES = 'GalleriUserMetrics';
